import React, { useEffect, useState, } from 'react'
import { useParams } from 'react-router';

import axios from 'axios';

import useAuth from '../../controllers/users/useAuth';

import {
    checkIfCallPrinterAsync, responseGet, globalSettings, styles, sendMessageCloseCurrentWindowAsync, dateTimeFormatGlobalSet, separatorsNumbersSet, awaitDelay, numberSet, languageObjGet,
    isUndNullEmp, LoadingSection
} from '../../helpers/settings';
import { purchaseStatusGet } from '../../controllers/purchases/purchases';
import HtmlParser from 'react-html-parser';
import { GlobalFormats } from '../../classes/main/globalFormats';
import moment from 'moment';

const currentMethod = 'SupplierCurrentBalancePrint';

export default function SupplierCurrentBalancePrint({
    languageObj = GlobalFormats?.class(languageObjGet({ subMethod: currentMethod, })?.result),
}) {
    //#region variables
    let result;
    //let dataObj = {};
    let headerObj = {};
    const auth = useAuth();
    const { id, } = useParams();
    const descriptionPercentageObj = {
        success: 'description-percentage text-success',
        primary: 'description-percentage text-primary',
        danger: 'description-percentage text-danger',
    };
    //#endregion variables

    //#region building
    const [building, setBuilding] = useState({});
    //#endregion building

    //#region showLoading
    const [showLoading, setShowLoading] = useState(true);
    //#endregion showLoading

    //#region purchases
    const [purchases, setPurchases] = useState({});
    const [purchasesBeforeBalance, setPurchasesBeforeBalance] = useState(numberSet({ number: 0.00, type: 'd', languageId: languageObj?.id, subMethod: 'setPurchasesBeforeBalance', })?.result);
    const [purchasesPeriodBalance, setPurchasesPeriodBalance] = useState(numberSet({ number: 0.00, type: 'd', languageId: languageObj?.id, subMethod: 'setPurchasesPeriodBalance', })?.result);
    const [purchasesCurrentBalance, setPurchasesCurrentBalance] = useState(numberSet({ number: 0.00, type: 'd', languageId: languageObj?.id, subMethod: 'setPurchasesCurrentBalance', })?.result);
    //#endregion purchases

    //#region supplier
    const [supplier, setSupplier] = useState({});
    //#endregion supplier

    //#region user
    const [user, setUser] = useState({});
    //#endregion user

    //#region user (methods)
    const userDataGet = ({ subMethod = '', }) => {
        const currentMethod = 'userDataGet';
        let response = responseGet();
        response.result = {
            firstName: '',
            lastName: '',
            fullName: '',
            email: '',
        }
        try {
            //#region methods
            if (!isUndNullEmp({ data: user?.firstName, subMethod: currentMethod, })?.result) {
                response.result.firstName = user?.firstName;
                if (!isUndNullEmp({ data: user?.lastName, subMethod: currentMethod, })?.result) {
                    response.result.lastName = user?.lastName;
                    response.result.fullName += `${user?.firstName}, ${user?.lastName}`;
                } else {
                    response.result.fullName += `${user?.firstName}`;
                }

                //#region old code
                // if (!isUndNullEmp({ data: user?.email, subMethod: currentMethod, })?.result) {
                //     response.result.email = user?.email;
                // }
                //#endregion old code
            } else {
                if (!isUndNullEmp({ ata: user?.displayName, subMethod: currentMethod, })?.result) {
                    response.result.firstName = user?.displayName;
                    response.result.fullName = user?.displayName;
                }
                response.result.lastName = user?.lastName || '';
                //#region old code
                // if (!isUndNullEmp({ data: user?.email, subMethod: currentMethod, })?.result) {
                //     response.result.email = user?.email;
                // }
                //#endregion old code
            }

            if (!isUndNullEmp({ data: user?.email, subMethod: currentMethod, })?.result) {
                response.result.email = user?.email;
            }
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            response.result = response?.msgText;
            console?.error(response);
        }
        return response;
    }
    //#endregion user (methods)

    //#region methods
    const dataGetAsync = async ({ subMethod = '', }) => {
        const currentMethod = 'dataGetAsync'
        let response = responseGet();
        try {
            //#region variables
            let suppierBalance = {};
            let sHowPrinterPromp = false;
            //#endregion variables

            setShowLoading(true);

            //#region data get (report)
            headerObj = {
                headers: {
                    authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                    languageId: languageObj?.id,
                },
                url: `${globalSettings?.app?.backend?.url}${globalSettings?.app?.backend?.urlApiV1}${globalSettings?.app?.backend?.urlReports}/${id}`,
            };

            result = await axios?.get(
                headerObj?.url,
                headerObj
            );

            response = result?.data;

            if (!response?.isSuccess || response?.isWarning) {
                setShowLoading(false);
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: true,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }

            suppierBalance = response?.result;
            setPurchases(suppierBalance);
            //#endregion data get (report)

            //#region get supplier
            setSupplier(suppierBalance?.supplier);
            //#endregion get supplier

            //#region building get
            setBuilding(suppierBalance?.building);
            //#endregion building get

            //#region user get
            setUser(suppierBalance?.user);
            //#endregion building get

            //#region set resume data
            setPurchasesBeforeBalance(suppierBalance?.purchases?.resume?.beforeBalance);
            setPurchasesPeriodBalance(suppierBalance?.purchases?.resume?.periodBalance);
            setPurchasesCurrentBalance(suppierBalance?.purchases?.resume?.currentBalance);
            //#endregion set resume data

            //#region show printer promp
            response = await checkIfCallPrinterAsync({
                checkIfOnlyIsMobile: false,
                subMethod: currentMethod,
            });

            if (!response.isSuccess) {
                setShowLoading(false);
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }

            sHowPrinterPromp = response?.result || false;
            setShowLoading(false);

            if (sHowPrinterPromp) {
                //await new Promise(r => setTimeout(r, globalSettings?.timers?.oneSecond));
                await awaitDelay({ delayTimer: globalSettings?.timers?.oneSecond, });
                window?.addEventListener('load', window?.print());
            }
            //#endregion show printer promp
        } catch (ex) {
            setShowLoading(false);
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const dataDetailGet = ({
        processType = 0,
        purchase = {
            id: '',
            number: 0,
            date: '',
            invoiceNumber: '',
            invoiceControlNumber: '',
            balance: 0.00,
            total: 0.00,
        },
        subMethod = '',
    }) => {
        const currentMethod = 'dataDetailGet';
        let response = responseGet();
        try {
            switch (processType) {
                case 0:
                    response.result = purchase?.id;
                    break;
                case 1:
                    response.result = purchase?.number || 0;
                    break;
                case 2:
                    response.result = dateTimeFormatGlobalSet({
                        date: purchase?.date || new Date(),
                        type: languageObj?.format?.date?.f1,
                        format: 0,
                        addTime: false,
                        secondsShow: false,
                        languageId: languageObj?.id,
                        subMethod: currentMethod,
                    })?.result;
                    break;
                case 3:
                    response.result = purchase?.invoiceNumber || '';
                    break;
                case 4:
                    response.result = purchase?.invoiceControlNumber || '';
                    break;
                case 5:
                    response.result = !isUndNullEmp({ data: purchase, subMethod: currentMethod, })?.result ?
                        purchaseStatusGet({
                            purchase: purchase,
                            showStateLabel: false,
                            htmlParser: true,
                            languageId: languageObj?.id,
                            subMethod: currentMethod,
                        })?.result :
                        '';
                    break;
                case 6:
                    response.result = separatorsNumbersSet({
                        number: purchase?.balance || 0.00,
                        withDecimals: true,
                        consoleLogErrorShow: true,
                        subMethod: currentMethod,
                    })?.result;
                    break;
                case 7:
                    response.result = separatorsNumbersSet({
                        number: purchase?.total || 0.00,
                        withDecimals: true,
                        consoleLogErrorShow: true,
                        subMethod: currentMethod,
                    })?.result;
                    break;
                default:
                    break;
            }
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            response.result = response?.msgText;
            console?.error(response);
        }
        return response;
    }

    useEffect(() => {
        dataGetAsync({ subMethod: 'form - onLoad', });
    }, []) //eslint-disable-line react-hooks/exhaustive-deps

    //#endregion methods

    return (
        <div>
            {/* <div style={{margin: '3px'}}> */}
            {!showLoading ?
                <div className='container mt-4'>

                    <div className='card card-outline card-secondary elevation-3 shadow-lg'>
                        <div className='card-header'>
                            <h5 className='card-title'>
                                <img src={globalSettings?.images?.appLogo}
                                    alt='appLogo'
                                    className='brand-image img-circle elevation-3'
                                    style={styles.receiptPrintLogo} />
                                {globalSettings?.app?.name}

                                <div className='text-muted' style={{ fontSize: '13px' }}>
                                    {HtmlParser(globalSettings?.html?.space?.formatSevenTeen)}{globalSettings?.messages?.theOnlyAndBestProgramInCondominiumManagement?.[languageObj?.id]}
                                </div>
                            </h5>

                            <div className='card-tools text-small'>
                                <ul className='list-unstyled float-right'>
                                    <li>
                                        {`${globalSettings?.labels?.date?.[languageObj?.id]}:`} <b>{
                                            dateTimeFormatGlobalSet({
                                                date: new Date(),
                                                type: languageObj?.format?.date?.f1,
                                                format: 0,
                                                addTime: false,
                                                secondsShow: false,
                                                languageId: languageObj?.id,
                                                subMethod: 'lbl - reportHeaderDate',
                                            })?.result
                                        }</b>
                                    </li>
                                    <li>
                                        {`${globalSettings?.labels?.time?.[languageObj?.id]}:`} <b>{
                                            dateTimeFormatGlobalSet({
                                                date: new Date(),
                                                type: '',
                                                format: languageObj?.format?.time?.type,
                                                addTime: false,
                                                secondsShow: false,
                                                languageId: languageObj?.id,
                                                subMethod: 'lbl - reportHeaderTime',
                                            })?.result
                                        }</b>
                                    </li>
                                    <li>
                                        {`${globalSettings?.labels?.user?.[languageObj?.id]}:`} <b>{userDataGet({ subMethod: 'lbl - reportHeadUser', })?.result?.fullName}</b>
                                    </li>
                                </ul>
                            </div>

                            {/* <div className='row'>
                                    <div className='col-12'>
                                        <h4 className='page-header'>
                                            <img src={globalSettings?.images?.appLogo} 
                                                alt='appLogo' 
                                                className='brand-image img-circle elevation-3'
                                                style={styles.receiptPrintLogo} /> {globalSettings?.app?.name}
                                            <ul className='list-unstyled float-right'>
                                                <li>
                                                    <small>{`${globalSettings?.labels?.date?.[languageObj?.id]}: ${dateTimeFormatSetTwo(new Date(), globalSettings?.react?.tempusDominus?.format?.date?.dmy, 0)}`}</small>
                                                </li>
                                                <li>
                                                    <small>{`${globalSettings?.labels?.time?.[languageObj?.id]}: ${dateTimeFormatSetTwo(new Date(), '', 12)}`}</small>
                                                </li>
                                            </ul>
                                        </h4>
                                    </div>
                                </div> */}
                        </div>
                        <div className='card-body'>

                            {/* <div className='row'> */}
                            <div className='text-center'>
                                <h5>
                                    {globalSettings?.labels?.supplier?.[languageObj?.id]} <br />
                                    <b>({globalSettings?.labels?.purchases?.[languageObj?.id]?.toLowerCase()} / {globalSettings?.labels?.movements?.[languageObj?.id]?.toLowerCase()})</b>
                                </h5>
                            </div>
                            {/* </div> */}

                            <section className='invoice'>

                                {/* title row */}
                                {/* <div className='row'>
                                        <div className='col-12'>
                                            <h4 className='page-header'>
                                                <img src={globalSettings?.images?.appLogo} 
                                                    alt='appLogo' 
                                                    className='brand-image img-circle elevation-3'
                                                    style={styles.receiptPrintLogo} /> {globalSettings?.app?.name}
                                                <ul className='list-unstyled float-right'>
                                                    <li>
                                                        <small>{`${globalSettings?.labels?.date?.[languageObj?.id]}: ${dateTimeFormatSetTwo(new Date(), globalSettings?.react?.tempusDominus?.format?.date?.dmy, 0)}`}</small>
                                                    </li>
                                                    <li>
                                                        <small>{`${globalSettings?.labels?.time?.[languageObj?.id]}: ${dateTimeFormatSetTwo(new Date(), '', 12)}`}</small>
                                                    </li>
                                                </ul>
                                            </h4>
                                        </div>
                                    </div> */}
                                {/* 
                                    <div className='row'>
                                        <div className='cold-12'>
                                            <hr />
                                        </div>
                                    </div> */}

                                {/* info row */}
                                <div className='row invoice-info'>
                                    <div className='col-sm-4 invoice-col'>
                                        <address className='mx-2'>
                                            {globalSettings?.labels?.building?.[languageObj?.id]}: <b>{building?.description || ''}</b><br />
                                            {globalSettings?.labels?.phone?.[languageObj?.id]}: {building?.phoneNumber || ''}<br />
                                            {globalSettings?.labels?.address?.[languageObj?.id]}: {building?.address || ''}<br />
                                            {globalSettings?.labels?.email?.[languageObj?.id]}: {building?.email || ''}<br />
                                            {/* <i className='far fa-building'></i> <b>{!isUndefined(building.description) ? building.description : ''}</b><br/>
                                                <i className='fas fa-mobile-alt'></i> {!isUndefined(building.phoneNumber) ? building.phoneNumber : ''}<br/>
                                                <i className={globalSettings?.icons?.mapMarker}></i> {!isUndefined(building.address) ? building.address : ''}<br/>
                                                <i className={globalSettings?.icons?.envelope}></i> {!isUndefined(building.email) ? building.email : ''}<br/> */}
                                        </address>
                                    </div>
                                    {/* /.col */}
                                    <div className='col-sm-4 invoice-col border-left'>
                                        <address>
                                            {globalSettings?.labels?.supplier?.[languageObj?.id]}: <b>{supplier?.description || ''}</b><br />
                                            {globalSettings?.labels?.rif?.[languageObj?.id]}: <b>{supplier?.rif || ''}</b><br />
                                            {globalSettings?.labels?.created?.[languageObj?.id]}: <b>{
                                                dateTimeFormatGlobalSet({
                                                    date: supplier?.date || new Date(),
                                                    type: languageObj?.format?.date?.f1,
                                                    format: 0,
                                                    addTime: true,
                                                    secondsShow: false,
                                                    languageId: languageObj?.id,
                                                    subMethod: 'lbl - reportMiddleCreateDate',
                                                })?.result
                                            }</b><br />
                                            {globalSettings?.labels?.email?.[languageObj?.id]}: <b>{supplier?.email || ''}</b><br />
                                            {globalSettings?.labels?.phone?.[languageObj?.id]}: <b>{supplier?.phoneNumber || ''}</b><br />
                                        </address>

                                    </div>
                                    {/* /.col */}
                                    <div className='col-sm-4 invoice-col border-left'>
                                        {globalSettings?.labels?.filters?.[languageObj?.id]}:<br />
                                        {/* {globalSettings?.labels?.from?.[languageObj?.id]}: <b>{`${!isUndefined(purchases?.dateFrom) && !isUndefined(purchases?.dateFrom.seconds)
                                            ? dateTimeFormatSet(purchases?.dateFrom.seconds, globalSettings?.react?.tempusDominus?.format?.date?.dmy, 0)
                                            : dateTimeFormatSetTwo(purchases?.dateFrom, globalSettings?.react?.tempusDominus?.format?.date?.dmy, 0, true)}`}</b><br />
                                        {globalSettings?.labels?.to?.[languageObj?.id]}: <b>{`${!isUndefined(purchases?.dateTo) && !isUndefined(purchases?.dateTo.seconds)
                                            ? dateTimeFormatSet(purchases?.dateTo.seconds, globalSettings?.react?.tempusDominus?.format?.date?.dmy, 0)
                                            : dateTimeFormatSetTwo(purchases?.dateTo, globalSettings?.react?.tempusDominus?.format?.date?.dmy, 0, true)}`}</b><br /> */}
                                        {globalSettings?.labels?.from?.[languageObj?.id]}: <b>{
                                            dateTimeFormatGlobalSet({
                                                date: !isUndNullEmp({ data: purchases?.dateFrom, subMethod: 'lbl - reportMiddleDateFrom', })?.result ? moment(purchases?.dateFrom)?._d : new Date(),
                                                type: languageObj?.format?.date?.f1,
                                                format: 0,
                                                addTime: false,
                                                secondsShow: false,
                                                languageId: languageObj?.id,
                                                subMethod: 'lbl - reportMiddleDateFrom',
                                            })?.result
                                        }</b><br />
                                        {globalSettings?.labels?.to?.[languageObj?.id]}: <b>{
                                            dateTimeFormatGlobalSet({
                                                date: !isUndNullEmp({ data: purchases?.dateTo, subMethod: 'lbl - reportMiddleDateTo', })?.result ? moment(purchases?.dateTo)?._d : new Date(),
                                                type: languageObj?.format?.date?.f1,
                                                format: 0,
                                                addTime: false,
                                                secondsShow: false,
                                                languageId: languageObj?.id,
                                                subMethod: 'lbl - reportMiddleDateTo',
                                            })?.result
                                        }</b><br />
                                        {/* {globalSettings?.labels?.movements?.[languageObj?.id]}: <b>{`${!isUndefined(purchases?.type)
                                            ? (purchases?.type === 'a'
                                                ? globalSettings?.labels?.all?.[languageObj?.id] : (purchases?.type === 'i'
                                                    ? globalSettings?.labels?.incomes?.[languageObj?.id] : (purchases?.type === 'e'
                                                        ? globalSettings?.labels?.egresses?.[languageObj?.id] : ''))) : ''}`}</b><br /> */}
                                    </div>
                                    {/* /.col */}
                                </div>

                                {/* /.row */}
                                {/* Table row */}
                                <div className='row'>
                                    <div className='col-12 table-responsive'>
                                        <table className={globalSettings?.html?.dataTables?.formats?.smStripedBordered}>
                                            <thead>
                                                <tr>
                                                    <th style={{ width: '10%' }} className='text-right'>{globalSettings?.labels?.number?.[languageObj?.id]}</th>
                                                    <th style={{ width: '15%' }}>{globalSettings?.labels?.date?.[languageObj?.id]}</th>
                                                    <th style={{ width: '15%' }}>{globalSettings?.labels?.purchase?.[languageObj?.id]}</th>
                                                    <th style={{ width: '15%' }}>{globalSettings?.labels?.control?.[languageObj?.id]}</th>
                                                    <th style={{ width: '15%' }}>{globalSettings?.labels?.status?.[languageObj?.id]}</th>
                                                    <th style={{ width: '15%' }} className='text-right'>{globalSettings?.labels?.balance?.[languageObj?.id]}</th>
                                                    <th style={{ width: '15%' }} className='text-right'>{globalSettings?.labels?.neto?.[languageObj?.id]}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {!isUndNullEmp({ data: purchases?.purchases?.period, subMethod: 'table - body', })?.result && purchases?.purchases?.period?.length > 0 ?
                                                    purchases?.purchases?.period?.map((detail) => (
                                                        <tr key={dataDetailGet({ processType: 0, purchase: detail, subMethod: 'table - trId', })?.result}>
                                                            <td className='text-right'>{dataDetailGet({ processType: 1, purchase: detail, subMethod: 'table - tdNumber', })?.result}</td>
                                                            <td>{dataDetailGet({ processType: 2, purchase: detail, subMethod: 'table - tdDate', })?.result}</td>
                                                            <td>{dataDetailGet({ processType: 3, purchase: detail, subMethod: 'table - tdPurchase', })?.result}</td>
                                                            <td>{dataDetailGet({ processType: 4, purchase: detail, subMethod: 'table - tdControl', })?.result}</td>
                                                            <td>{dataDetailGet({ processType: 5, purchase: detail, subMethod: 'table - tdState', })?.result}</td>
                                                            <td className='text-right'>{dataDetailGet({ processType: 6, purchase: detail, subMethod: 'table - tdBalance', })?.result}</td>
                                                            <td className='text-right'>{dataDetailGet({ processType: 7, purchase: detail, subMethod: 'table - tdNet', })?.result}</td>

                                                            {/* <td style={{ fontSize: '13px' }}>{dataDetailGet(2, detail)?.result}</td>
                                                            <td className='text-right'>{dataDetailGet(3, detail)?.result}</td>
                                                            <td className='text-right'>{dataDetailGet(4, detail)?.result}</td> */}
                                                        </tr>
                                                    )) : null}
                                                {/* {!isUndefined(movementDetails) && movementDetails.length > 0 ?
                                                        map(movementDetails, (detail) => (
                                                            <tr key={detail.id}>
                                                                <td>{detail.date}</td>
                                                                <td>{detail.reference}</td>
                                                                <td className='text-right'>{detail.amount}</td>
                                                                <td className='text-right'>{detail.balance}</td>
                                                            </tr>
                                                        )) : null
                                                    } */}
                                            </tbody>
                                        </table>
                                    </div>
                                    {/* /.col */}
                                </div>

                                <hr />

                                {/* /.row */}
                                <div className='row'>
                                    {/* accepted payments column */}
                                    {/* <div className='col-6'>
                                            <p className='lead'>{globalSettings?.labels?.paymentMethods?.[languageObj?.id]}:</p>
                                            <img className='mx-1 elevation-3' src={globalSettings?.images?.visaLogo} alt='visa' />
                                            <img className='elevation-3'src={globalSettings?.images?.masterCardLogo} alt='mastercard' />
                                            <img className='mx-1 elevation-3' src={globalSettings?.images?.americanExpressLogo} alt='americanExpress' />
                                            <img className='elevation-3'src={globalSettings?.images?.payPalLogo} alt='paypal' />
                                            <img className='mx-1 elevation-3' src={globalSettings?.images?.zelleLogo} alt='zelle' />
                                            <img className='elevation-3' src={globalSettings?.images?.bankTransferLogo} alt='bankTranfer' />
                                            <p className='text-muted well well-sm shadow-none' style={{marginTop: 10}}>
                                            </p>
                                        </div> */}
                                    {/* /.col */}
                                    {/* <div className='col-6'>
                                            <p className='lead'></p>
                                            <div className='table-responsive'>
                                                <table className='table table-sm'>
                                                    <tbody><tr>
                                                        <th style={{width: '50%'}}>{globalSettings?.labels?.subTotal?.[languageObj?.id]}:</th>
                                                        <td className='text-right'>{separatorsNumbersSet(apartmentReceipt.total)}</td>
                                                    </tr>
                                                    <tr>
                                                        <th>{globalSettings?.labels?.tax.es} (0.00%):</th>
                                                        <td className='text-right'>0.00</td>
                                                    </tr>
                                                    <tr>
                                                        <th>Total:</th>
                                                        <td className='text-right'>{apartmentReceipt.total}</td>
                                                    </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div> */}
                                    {/* /.col */}

                                    <div className='col-sm-4 col-6'>
                                        <div className='description-block border-right'>
                                            <span className={descriptionPercentageObj?.primary}>
                                                <i className={globalSettings?.icons?.caretLeft}></i> {
                                                    separatorsNumbersSet({
                                                        number: numberSet({
                                                            number: purchasesBeforeBalance,
                                                            type: 'd',
                                                            languageId: languageObj?.id,
                                                            subMethod: 'lbl - reportFooter - purchasesBeforeBalance',
                                                        })?.result,
                                                        withDecimals: true,
                                                        consoleLogErrorShow: true,
                                                        subMethod: 'lbl - reportFooter - purchasesBeforeBalance',
                                                    })?.result
                                                }
                                            </span>
                                            <h5 className='description-header'>---</h5>
                                            <span className='description-text'>{globalSettings?.labels?.previousBalance?.[languageObj?.id]}</span>
                                        </div>

                                    </div>

                                    <div className='col-sm-4 col-6'>
                                        <div className='description-block border-right'>
                                            <span className='description-percentage text-warning'>
                                                <i className={globalSettings?.icons?.caretUp}></i> {
                                                    //separatorsNumbersSet(numberSet(purchasesPeriodBalance, 'd')?.result, 'd')?.result
                                                    separatorsNumbersSet({
                                                        number: numberSet({
                                                            number: purchasesPeriodBalance,
                                                            type: 'd',
                                                            languageId: languageObj?.id,
                                                            subMethod: 'lbl - reportFooter - purchasesPeriodBalance',
                                                        })?.result,
                                                        withDecimals: true,
                                                        consoleLogErrorShow: true,
                                                        subMethod: 'lbl - reportFooter - purchasesPeriodBalance',
                                                    })?.result
                                                }
                                            </span>
                                            <h5 className='description-header'>---</h5>
                                            <span className='description-text'>{globalSettings?.labels?.periodBalance?.[languageObj?.id]}</span>
                                        </div>

                                    </div>

                                    <div className='col-sm-4 col-6'>
                                        <div className='description-block border-right'>
                                            <span className={descriptionPercentageObj?.danger}>
                                                <i className={globalSettings?.icons?.caretRight}></i> {
                                                    //separatorsNumbersSet(numberSet(purchasesCurrentBalance, 'd')?.result, 'd')?.result
                                                    separatorsNumbersSet({
                                                        number: numberSet({
                                                            number: purchasesCurrentBalance,
                                                            type: 'd',
                                                            languageId: languageObj?.id,
                                                            subMethod: 'lbl - reportFooter - purchasesCurrentBalance',
                                                        })?.result,
                                                        withDecimals: true,
                                                        consoleLogErrorShow: true,
                                                        subMethod: 'lbl - reportFooter - purchasesCurrentBalance',
                                                    })?.result
                                                }
                                            </span>
                                            <h5 className='description-header'>---</h5>
                                            <span className='description-text'>{globalSettings?.labels?.currentBalance?.[languageObj?.id]}</span>
                                        </div>

                                    </div>
                                </div>
                                {/* /.row */}

                                <div className='row'>
                                    <div className='col-12'>
                                        <hr style={{ height: '0.5' }} />
                                    </div>
                                </div>

                                <div className='row text-center' style={{ fontSize: 12 }}>
                                    <div className='col-sm-3 text-muted'>
                                        {`${globalSettings?.app?.company?.name} `}
                                    </div>
                                    <div className='col-sm-3 text-muted'>
                                        {`${globalSettings?.app?.company?.slogan}`}
                                    </div>
                                    <div className='col-sm-3 text-muted'>
                                        {`${globalSettings?.app?.company?.url}`}
                                    </div>
                                    <div className='col-sm-3 text-muted'>
                                        {`${globalSettings?.app?.name} / ${globalSettings?.app?.version} / ${globalSettings?.app?.year}`}
                                    </div>
                                </div>

                            </section>

                        </div>
                    </div>

                </div>
                :
                <div className='text-center'
                    style={{ paddingTop: '50px', }}>
                    <LoadingSection alt='loadingSection'
                        className={globalSettings?.react?.html?.overlay?.textMued}
                        //className='overlay text-muted'
                        showText={true}
                        text={globalSettings?.messages?.processing?.[languageObj?.id]}
                        height={25}
                        hidden={!showLoading}
                        languageId={languageObj?.id}
                        width={25}
                        subMethod={currentMethod} />
                </div>
            }

            {/* </div> */}
        </div>
    )
}